import { render } from "./scoreQuery.vue?vue&type=template&id=2f515aec&scoped=true"
import script from "./scoreQuery.vue?vue&type=script&lang=js"
export * from "./scoreQuery.vue?vue&type=script&lang=js"

import "./scoreQuery.vue?vue&type=style&index=0&id=2f515aec&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f515aec"]])

export default __exports__